<template>
    <div v-if="label" class="main-container">
        <h2 class="subtitle">{{label.titles.title}}
          <Info multilined bottom tooltipText="Visualisez vos relevés d'index mensuels"/>
        </h2>
        <PodSelection v-bind:userId="user._id" @selectedPod="onPodSelected"/>
        <div>
            <!-- Index -->
            <!-- Table -->
            <div class="table-container" :class="{ 'loading': loadingIndexes }">
              <table class="table is-hoverable">
                <thead>
                  <tr>
                    <th>{{label.forms.date}}</th>
                    <th v-for="variable in variables" v-bind:key="variable.name">
                      {{getRegisterFriendlyName(variable.name)}}
                    </th>
                    <th>{{label.forms.unit}}</th>
                    <!-- <th>{{label.forms.source}}</th> -->
                    <!-- <th class="has-text-centered">{{label.forms.actions}}</th> -->
                  </tr>
                </thead>
                <tbody>
                  <!-- <tr v-show="indexesPageIndex === 0 && canAddMeteringToday && allowedToAddIndex">
                    <td
                      class="add-index has-text-centered"
                      colspan="20"
                      @click="createIndexModal()">
                      <awesome-icon class="button-icon" icon="plus"/>{{label.buttons.addIndex}}
                    </td>
                  </tr> -->
                  <template v-if="indexes && indexes.length > 0 && !loadingIndexes">
                    <tr v-for="index in indexes" v-bind:key="index.transactionID">
                      <td>{{prettyFormatDate(index.date)}}</td>
                      <td v-for="variable in variables" v-bind:key="variable.name">
                        {{indexVariable(index.meterings, variable)}}
                      </td>
                      <td>{{pod.energy.inputUnit}}</td>
                      <!-- <td>{{index.source === 'user' ? "Client" : "GRD"}}</td> -->

                      <!-- <td v-if="index.source === 'user' && allowedToModifyIndex && allowedToDeleteIndex" class="has-text-centered">
                        <a class="button is-outlined is-info is-small" style="margin-right: 10px;" @click="editIndexModal(index)">{{label.buttons.edit}}</a>
                        <a class="button is-outlined is-danger is-small" @click="deleteIndex(index)">{{label.buttons.delete}}</a>
                      </td> -->
                      <!-- <td v-else class="has-text-centered">
                        <a disabled class="button is-outlined is-info is-small" style="margin-right: 10px;"
                          :data-tooltip="label.texts.unauthorizedAction">{{label.buttons.edit}}</a>
                        <a disabled class="button is-outlined is-danger is-small"
                          :data-tooltip="label.texts.unauthorizedAction">{{label.buttons.delete}}</a>
                      </td> -->
                    </tr>
                  </template>
                  <template v-else>
                    Pas d'index mensuels à visualiser
                  </template>
                </tbody>
              </table>
            </div>

            <!-- Pagination -->
            <div class="field is-grouped">
              <div class="control">
                <button
                  :disabled="indexesPageIndex <= 0 || loadingIndexes"
                  class="button is-small"
                  @click="indexesPageIndex--">{{label.buttons.before}}</button>
              </div>
              <div class="control"><span class="is-size-7"><strong>{{label.buttons.page}} {{indexesPageIndex+1}}</strong></span></div>
              <div class="control">
                <button
                  :disabled="onLastIndexPage || loadingIndexes"
                  class="button is-small"
                  @click="indexesPageIndex++">{{label.buttons.after}}</button>
                </div>
            </div>

            <!-- Create/edit modal -->
            <IndexModal
              :openModal="showModalIndex"
              :showCreationForm="showCreationForm"
              :pod="pod"
              :index="editIndex"
              :minMeteringDate="minMeteringDate"
              :reloadData="loadIndexes"
              :closeModal="closeModal"
            />
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import PodSelection from '../components/PodSelection.vue';
import IndexModal from '../components/IndexModal.vue';
import { MeteringService } from '../services';
import moment from 'moment';
import { DB_COLLECTIONS, getDelegationRight, whatCanDelegatedUserDo, getRegisterFriendlyName, formatNumberWithThousandsSeparator } from '../helpers'
import Info from '../components/Info.vue'

export default {
    components: {
        PodSelection,
        IndexModal,
        Info
    },
    data() {
        return {
            indexes: [],
            variables: [],
            clipodStartDate: null,
            pod: {},
            activeClipod : null,
            meterings: [],
            periodicalConsumptions: [],
            indexesPageIndex: 0,
            consumptionsPageIndex: 0,
            number: 10,
            onLastIndexPage: true,
            onLastConsumptionsPage: false,
            loadingIndexes: false,
            loadingConsumptions: false,

            threeYearsAgo: moment().subtract(3, "years"),
            oldErrors: {
                value: false
            },
            // if false, a modification form is being shown and a different api call
            // is made when submitting
            showCreationForm: true,
            showModalIndex: false,
            editIndex: null
        }
    },
    computed: {
        ...mapState("account", ["user"]),
        ...mapState({ label: state => state.labels.indexes }),
        ...mapState({ locale: state => state.labels.locale }),
        physicalRegisters() {
        // Exclude PWR and PWR_EX variables from listing
        return this.activeClipod.pod.variable.filter(v => v.meter && v.timeframe !== 'PWR' && v.timeframe !== 'PWR_EX');
        },
        delegationRight() {
          if(!this.activeClipod || !this.activeClipod.isDelegatedAccess)
            return null
          return getDelegationRight(this.activeClipod)
        },
        allowedToAddIndex() {
          if(!this.activeClipod)
            return false
          if(!this.activeClipod.isDelegatedAccess)
            return true
          if(!this.delegationRight)
            return false
          const meteringPermissions = whatCanDelegatedUserDo({ collection: DB_COLLECTIONS.METERING, delegationRight: this.delegationRight })
          return meteringPermissions && meteringPermissions.canCreateNew
        },
        // allowedToModifyIndex() {
        //   if(!this.activeClipod)
        //     return false
        //   if(!this.activeClipod.isDelegatedAccess)
        //     return true
        //   if(!this.delegationRight)
        //     return false
        //   const meteringPermissions = whatCanDelegatedUserDo({ collection: DB_COLLECTIONS.METERING, delegationRight: this.delegationRight })
        //   return meteringPermissions && meteringPermissions.canModify
        // },
        // allowedToDeleteIndex() {
        //   if(!this.activeClipod)
        //     return false
        //   if(!this.activeClipod.isDelegatedAccess)
        //     return true
        //   if(!this.delegationRight)
        //     return false
        //   const meteringPermissions = whatCanDelegatedUserDo({ collection: DB_COLLECTIONS.METERING, delegationRight: this.delegationRight })
        //   return meteringPermissions && meteringPermissions.canDelete
        // },
        minMeteringDate() {
            let minDate;
            if(this.indexes.length > 0)
                minDate = moment(this.indexes[0].date).add(1,"days");
            else
                minDate = moment(this.clipodStartDate);
            if(minDate < this.threeYearsAgo) {
                return this.threeYearsAgo.format("YYYY-MM-DD");
            }
            return minDate.format("YYYY-MM-DD");
        },
        // checks if the user already encoded a value for today
        canAddMeteringToday() {
            if(!this.indexes[0]) {
                // if onLastIndexPage is true here it means there's no value for this variable yet
                // if its false it means its still loading the data
                return this.onLastIndexPage
            }
            let startOfDay = moment().local().startOf('day').toDate()
            return startOfDay > new Date(this.indexes[0].date)
        }
    },
    methods: {
        ...mapActions("labels", ["getLabel"]),
        getRegisterFriendlyName(registerName) {
            return getRegisterFriendlyName(registerName)
        },
        prettyFormatDate(date) {
          return moment(date).format('DD-MM-YYYY')
        },
        onPodSelected(clipod) {
          // Defensive: if no clipod (no access points), clear state and return
          if (!clipod) {
            this.indexesPageIndex = 0;
            this.clipodStartDate = null;
            this.pod = {};
            this.activeClipod = null;
            this.variables = [];
            this.indexes = [];
            return;
          }

          this.indexesPageIndex = 0;
          this.clipodStartDate = clipod.validFrom;
          this.pod = clipod.pod;
          this.activeClipod = clipod
          // check that there is at least one register for the pod
          if(this.pod.variable.length > 0) {
            this.loadIndexes();
          }
        },
        loadIndexes() {
            // load periodical indexes
            this.showModalIndex = false;
            this.meterings = [];
            this.loadingIndexes = true;
            let nbRegisters = this.pod.variable.length;
            let nbIndexes = nbRegisters;
            while(nbIndexes < 10) {
                nbIndexes += nbRegisters;
            }
            this.number = nbIndexes;

            MeteringService.getIndexes(
              this.physicalRegisters.map(v => v.id),
              this.pod.id,
              this.user._id,
              this.indexesPageIndex,
              this.number,
              true
            ).then(
              meteringsInfos => {
                this.loadingIndexes = false;
                if(meteringsInfos) {
                  if(this.pod.energy.energyName == "elec") {
                    meteringsInfos.variables.sort((a,b) => {
                        const timeframeOrder = {
                          "TH": 1, // Mono-horaire
                          "HI": 2, // Heures pleines
                          "LO": 3, // Heures creuses
                          "PK": 4, // Heures pics
                          "MD": 5, // Heures medium
                          "EC": 6,  // Heures écos
                          "EX": 7 // Exclusif nuit
                        };
                        const directionOrder = {
                          "prelevement": 1,
                          "injection": 2
                        };
                        
                        // Extraire timeframe et direction depuis le nom (ex: "TH_prelevement")
                        const aParts = a.name ? a.name.split('_') : [];
                        const bParts = b.name ? b.name.split('_') : [];
                        
                        const aTf = (a.timeframe || aParts[0] || '').toUpperCase();
                        const aDir = (a.direction || aParts[1] || '').toLowerCase();
                        const bTf = (b.timeframe || bParts[0] || '').toUpperCase();
                        const bDir = (b.direction || bParts[1] || '').toLowerCase();
                        
                        const tfA = timeframeOrder[aTf] || 99;
                        const tfB = timeframeOrder[bTf] || 99;
                        
                        if (tfA !== tfB) {
                            return tfA - tfB;
                        }
                        
                        const dirA = directionOrder[aDir] || 99;
                        const dirB = directionOrder[bDir] || 99;
                        
                        if (dirA !== dirB) {
                            return dirA - dirB;
                        }
                        
                        return (a.name || '').localeCompare(b.name || '');
                    });
                  }
                  this.onLastIndexPage = meteringsInfos.lastPage;
                  this.variables = meteringsInfos.variables;
                  this.indexes = meteringsInfos.index;
                }
                else {
                  this.onLastIndexPage = true;
                  this.variables = []
                  this.indexes = []
                }
              }
            )
            .finally(() => this.loadingIndexes = false)
        },
        createIndexModal() {
          this.loadingIndexes = true;
          this.showCreationForm = true;
          this.showModalIndex = true;
        },
        editIndexModal(index) {
          this.loadingIndexes = true;
          this.editIndex = index
          this.showCreationForm = false
          this.showModalIndex = true
        },
        deleteIndex(index) {
          if(confirm(`${this.label.texts.deleteConfirm} ${moment(index.date).format("DD-MM-YYYY")} ?`)) {
            MeteringService.deleteMetering(this.user._id, this.pod.id, index.transactionID).then(() => {
              this.loadIndexes();
            });
          }
        },
        closeModal(isCancelled) {
          isCancelled ? this.loadingIndexes = false : null;
          this.showModalIndex = false;
        },
        indexVariable(meterings, variable) {
          const index = meterings.find(elem => elem.variable.name == variable.name)
          return index ? formatNumberWithThousandsSeparator(index.value) : "--"
        }
    },
    created() {
      this.getLabel({ view: 'indexes' });
    },
    watch: {
        indexesPageIndex() {
            this.loadIndexes();
        }
    }
}
</script>

<style lang="scss" scoped>
.table-container {
  margin-top: 30px;
}

.add-index {
  cursor: pointer;

  &:hover {
    background-color: #8796c9;
    color: white;
  }
}

.no-pointer {
  cursor: default;
}
</style>